const UNSAVED_LEAVE_MESSAGE = 'Есть несохранённые изменения. Выйти без сохранения?';

type LeaveChecker = () => boolean;

let leaveChecker: LeaveChecker | null = null;

export function getUnsavedLeaveMessage(): string {
  return UNSAVED_LEAVE_MESSAGE;
}

/** Register a dirty-form checker for Admin SPA navigation. Returns disposer. */
export function registerAdminLeaveGuard(checker: LeaveChecker): () => void {
  leaveChecker = checker;
  return () => {
    if (leaveChecker === checker) {
      leaveChecker = null;
    }
  };
}

export function confirmAdminNavigation(): boolean {
  if (leaveChecker === null || !leaveChecker()) {
    return true;
  }
  return window.confirm(UNSAVED_LEAVE_MESSAGE);
}
